import PropTypes from 'prop-types';
import React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
// import { addStyle } from 'react-bootstrap/lib/utils/bootstrapUtils';
import labels from '../labels';
import './PaneMenu.css';





// addStyle(Button, 'player-control');


const PaneMenu = ({
  paneMenuEntries,
  visiblePanes,
  onPaneToggle,
  unreadChatMessages,
}) => (
  <Dropdown
  id="panes-dropup"
  
  >
  <Dropdown.Toggle id="dropdown-basic" style={{background: "transparent", border: "none"}}/>

  <Dropdown.Menu
    className={unreadChatMessages ? 'panes-notify-unread-messages' : ''}
    dropup
    noCaret
    pullRight
    bsStyle="player-control"
    // title={
    //   <Glyphicon className="player-pane-menu-icon" glyph="modal-window" />
    // }
    onSelect={onPaneToggle}
    id="panes-dropup"
    aria-label={labels.paneMenu}
  >
    {Object.getOwnPropertyNames(paneMenuEntries).map((tag, i) => {
      const visible = visiblePanes.indexOf(tag) !== -1;
      const style = { visibility: visible ? 'visible' : 'hidden' };
      return (
        <Dropdown.Item key={i} eventKey={tag}>
          <span style={style}>
            {/* <Glyphicon glyph="ok" /> */}
          </span>
          <span>
            {` ${paneMenuEntries[tag]}`}
          </span>
        </Dropdown.Item>
      );
    })}
  </Dropdown.Menu>
  </Dropdown>
);


PaneMenu.propTypes = {
  paneMenuEntries:    PropTypes.object.isRequired,
  visiblePanes:       PropTypes.arrayOf(PropTypes.string).isRequired,
  onPaneToggle:       PropTypes.func.isRequired,
  unreadChatMessages: PropTypes.bool.isRequired,
};


export default PaneMenu
